import getV10APIs from './v1.0';
import getV11APIs from './v1.1';
import getV12APIs from './v1.2';
import { mergeVersionsByTitle } from '../../../util/HelperFunctions';

const data = (userInfo) => {
  const v10APIs = getV10APIs(userInfo);
  const v11APIs = getV11APIs(userInfo);
  const v12APIs = getV12APIs(userInfo);

  const children = [
    mergeVersionsByTitle('SKU상품 리스트 조회', v12APIs),
    mergeVersionsByTitle('SKU상품 상세 리스트 조회', v11APIs),
    mergeVersionsByTitle('SKU상품 상세 조회', v12APIs),
    mergeVersionsByTitle('SKU상품 등록', v12APIs),
    mergeVersionsByTitle('SKU상품 수정', v12APIs),
    mergeVersionsByTitle('세트상품 조회', v10APIs),
    mergeVersionsByTitle('세트상품 등록', v10APIs),
    mergeVersionsByTitle('세트상품 수정', v10APIs),
    mergeVersionsByTitle('재고수정', v11APIs, v10APIs),
    mergeVersionsByTitle('재고현황조회', v10APIs),
  ].filter(Boolean);

  return { title: '재고', children };
};

export default data;
